import React from "react";
import { useNavigate } from "react-router-dom";
import "./Internship.css";

const domains = [
  {
    code: "FSD",
    title: "Full Stack Development",
    icon: "⚡",
    desc: "Build end-to-end web apps with React, Node.js, Express & MongoDB.",
    color: "#00c6ff",
  },
  {
    code: "PY",
    title: "Python Development",
    icon: "🐍",
    desc: "Automate, analyse, and build with Python — from scripts to web APIs.",
    color: "#f7c948",
  },
  {
    code: "JAVA",
    title: "Java Development",
    icon: "☕",
    desc: "Object-oriented programming, Spring Boot, and enterprise-grade projects.",
    color: "#ff6b35",
  },
  {
    code: "WAB",
    title: "Web App Building",
    icon: "🌐",
    desc: "Design and ship responsive, modern web applications from scratch.",
    color: "#7f5af0",
  },
  {
    code: "AI",
    title: "AI Tools & Automation",
    icon: "🤖",
    desc: "Integrate AI APIs, build chatbots, and automate real-world workflows.",
    color: "#2cb67d",
  },
];

const perks = [
  { icon: "📋", text: "Daily practical tasks" },
  { icon: "🎯", text: "Real-time project guidance" },
  { icon: "🏗️", text: "Final project development" },
  { icon: "🔏", text: "Certificate with QR verification" },
  { icon: "💻", text: "GitHub project support" },
  { icon: "🚀", text: "Career guidance" },
];

export default function Internship() {
  const navigate = useNavigate();

  return (
    <div className="internship-page">
      {/* Hero */}
      <section className="int-hero">
        <div className="int-hero-badge">Registered under Udyam / MSME</div>
        <h1 className="int-hero-title">
          30-Day Project-Based
          <br />
          <span className="int-gradient-text">Internship Program</span>
        </h1>
        <p className="int-hero-sub">
          Conducted by <strong>Ariyom Tech Solutions</strong> — online, practical, and project-driven.
        </p>
        <div className="int-hero-meta">
          <span className="int-pill">🌐 Online</span>
          <span className="int-pill">📅 30 Days</span>
          <span className="int-pill">💸 ₹499 only</span>
          <span className="int-pill seats">⚠️ Limited Seats</span>
        </div>
        <button className="int-cta-btn" onClick={() => navigate("/register-internship")}>
          Apply Now →
        </button>
      </section>

      {/* Domains */}
      <section className="int-section">
        <h2 className="int-section-title">Choose Your Domain</h2>
        <div className="int-domains-grid">
          {domains.map((d) => (
            <div className="int-domain-card" key={d.code} style={{ "--accent": d.color }}>
              <div className="int-domain-icon">{d.icon}</div>
              <div className="int-domain-code">ATS-{d.code}</div>
              <h3 className="int-domain-name">{d.title}</h3>
              <p className="int-domain-desc">{d.desc}</p>
              <button
                className="int-domain-btn"
                onClick={() => navigate("/register-internship", { state: { domain: d.title } })}
              >
                Register →
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* Perks */}
      <section className="int-section int-perks-section">
        <h2 className="int-section-title">What You Get</h2>
        <div className="int-perks-grid">
          {perks.map((p) => (
            <div className="int-perk-card" key={p.text}>
              <span className="int-perk-icon">{p.icon}</span>
              <span className="int-perk-text">{p.text}</span>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Banner */}
      <section className="int-cta-banner">
        <h2>Ready to build real projects?</h2>
        <p>Join hundreds of students who have completed our internship program.</p>
        <button className="int-cta-btn" onClick={() => navigate("/register-internship")}>
          Register Now — ₹499
        </button>
        <div className="int-verify-link">
          Already have a certificate?{" "}
          <span onClick={() => navigate("/verify")} className="int-link">
            Verify here →
          </span>
        </div>
      </section>
    </div>
  );
}